/*
    For our Localize-js functionality we have specific elements that are supposed to be translated and others
    that are not. These are easy to specify in regular <select> els, but because of how select2 renders it's
    selection UI, and underlying logic, the 'notranslate' attributes that can be applied to any element/parent
    of an option in a select don't work as they should.

    To remedy this, we create custom adapters to override some functionality within select2 to slightly modify
    the functionality & UI, to persist these 'notranslate' attributes.
 */

(function($) {

    // Define select2 overridden TagsAdapter to make sure user-typed custom options in searchable selects are
    // set to notranslate when added
    $.fn.select2.amd.define('select2/localizeTagsAdapter', [
        "select2/utils",
        "select2/data/tags"
    ], function (Utils, Tags) {

        function LocalizeTagsAdapter(){
            LocalizeTagsAdapter.__super__.constructor.call(this);
        }

        Utils.Extend(LocalizeTagsAdapter, Tags);

        // https://github.com/select2/select2/blob/master/src/js/select2/data/tags.js#L96
        LocalizeTagsAdapter.prototype.createTag = function (decorated, params) {
            var tag = LocalizeTagsAdapter.__super__.createTag.call(this, decorated, params);
            if(tag) tag.notranslate = true;
            return tag;
        };

        return LocalizeTagsAdapter;
    });

    // Define select2 overridden SelectAdapter to set data.notranslate value for each item (opt/optgroup) added
    // to the select2 element for which 'notranslate' is specified on el/parent el
    $.fn.select2.amd.define('select2/localizeDataAdapter', [
        "select2/utils",
        "select2/data/select",
        "select2/localizeTagsAdapter",
        "select2/data/minimumInputLength",
        "select2/data/maximumInputLength",
        "select2/data/maximumSelectionLength",
        "select2/data/ajax",
    ], function (Utils, SelectData, Tags, MinimumInputLength, MaximumInputLength, MaximumSelectionLength, Ajax) {

        return function (options) {

            function LocalizeDataAdapter($element, opts) {
                LocalizeDataAdapter.__super__.constructor.call(this, $element, opts);
            }

            if(options.ajax) {
              Utils.Extend(LocalizeDataAdapter, Ajax);
            } else {
              Utils.Extend(LocalizeDataAdapter, SelectData);
            }

            // https://github.com/select2/select2/blob/master/src/js/select2/data/select.js#L200
            LocalizeDataAdapter.prototype.item = function ($option) {
                var data = LocalizeDataAdapter.__super__.item.call(this, $option);

                // Look up the DOM tree to see if there's a notranslate tag on this el or any parent el
                data.notranslate = $option.closest("[notranslate]").length > 0;

                if (data.notranslate || options.notranslateAll) data.element.setAttribute('notranslate', '');

                return data;
            };

            // https://github.com/select2/select2/blob/master/src/js/select2/data/select.js#L157
            LocalizeDataAdapter.prototype.option = function(data) {
                var $option = LocalizeDataAdapter.__super__.option.call(this, data);
                if($option.length && data.notranslate) $option[0].setAttribute('notranslate', 'notranslate');
                return $option;
            };

            var adapter = LocalizeDataAdapter;

            if (options.tags) adapter = Utils.Decorate(adapter, Tags);

            // The following don't appear to be used in the app, but adding for posterity sake
            if(options.minimumInputLength > 0) adapter = Utils.Decorate(adapter, MinimumInputLength);
            if(options.maximumInputLength > 0) adapter = Utils.Decorate(adapter, MaximumInputLength);
            if(options.maximumSelectionLength > 0) adapter = Utils.Decorate(adapter, MaximumSelectionLength);
            // NOTE if we add any select2 behavior that does not appear to be working as we would expect, refer to
            // any missing decorations from the select2 defaults apply
            // https://github.com/select2/select2/blob/master/src/js/select2/defaults.js#L57

            return adapter;
        }
    });

    // Define select2 overridden resultsAdapter to add notranslate to displayed selection option
    // if needed based on notranslate value in data array (set by localizesSelectAdapter above)
    $.fn.select2.amd.define('select2/localizeResultsList', [
        "select2/utils",
        "select2/results",
        "select2/dropdown/hidePlaceholder",
        "select2/dropdown/selectOnClose"
    ], function (Utils, ResultsList, HidePlaceholder, SelectOnClose) {

        return function (options) {

            function LocalizeResultsList($element, options, dataAdapter) {
                LocalizeResultsList.__super__.constructor.call(this, $element, options, dataAdapter);
            }

            Utils.Extend(LocalizeResultsList, ResultsList);

            // https://github.com/select2/select2/blob/master/src/js/select2/results.js#L169
            LocalizeResultsList.prototype.option = function (data) {
                var option = LocalizeResultsList.__super__.option.call(this, data);
                if (!options.allowhtml && (data.notranslate || options.notranslateAll)) {
                    option.setAttribute('notranslate', '');
                }
                return option;
            };

            var adapter = LocalizeResultsList;

            // Decorate with needed adapters based on options
            // https://github.com/select2/select2/blob/master/src/js/select2/defaults.js#L120
            if (options.placeholder) {
                adapter = Utils.Decorate(
                    adapter,
                    HidePlaceholder
                );
            }
            if (options.selectOnClose) {
                adapter = Utils.Decorate(
                    adapter,
                    SelectOnClose
                )
            }
            return adapter;
        }
    });

    // Define select2 overridden SingleSelection to add notranslate to placeholder for rendering. This works because
    // we depend on notranslate on/off the child element for the text to be translated or not
    $.fn.select2.amd.define('select2/localizeSelection', [
        "select2/utils",
        "select2/selection/single",
        "select2/selection/multiple",
        "select2/selection/placeholder",
        "select2/selection/allowClear",
        "select2/dropdown/minimumResultsForSearch",
        "select2/selection/search",
        "select2/selection/eventRelay"
    ], function (Utils, SingleSelection, MultipleSelection, Placeholder, AllowClear, MinimumResultsForSearch, SelectionSearch, EventRelay) {

        return function (options) {

            function LocalizeSelection() {
                LocalizeSelection.__super__.constructor.apply(this, arguments);
            }

            if (options.multiple) {
                Utils.Extend(LocalizeSelection, MultipleSelection);
            } else {
                Utils.Extend(LocalizeSelection, SingleSelection);
            }

            // Function is the same for both single & multiple
            // https://github.com/select2/select2/blob/master/src/js/select2/selection/single.js#L72
            // https://github.com/select2/select2/blob/master/src/js/select2/selection/multiple.js#L61
            LocalizeSelection.prototype.display = function (data, container) {
                var template = this.options.get('templateSelection'),
                    rendered = template(data, container);

                // WRAP in a <var> element if notranslate and add title
                var text_val = $('<div/>').html(rendered).text(),
                    $el = $("<span/>");

                $el = options.allowhtml ? $el.html(rendered) : $el.text(rendered)

                if (!options.allowhtml && (data.notranslate || options.notranslateAll)) {
                    $el[0].setAttribute('notranslate', 'notranslate');
                }

                return $el[0].outerHTML;
            };

            // Select2 sets title of attribute on select2-selection__rendered. This element has zero notranslate logic
            // applied to it, relying on the children to be wrapped in <var> where needed. Instead, we are removing the
            // title from the select2-selection__rendered element and adding the title to the elements generated in
            // display above. The only case where this might get wonky is super short multi-select instances as some
            // could be hidden from view so you couldn't hover over to expand title, but all use cases for single select
            // will work perfect
            //
            // https://github.com/select2/select2/blob/master/src/js/select2/selection/single.js
            // https://github.com/select2/select2/blob/master/src/js/select2/selection/multiple.js#L80
            LocalizeSelection.prototype.update = function(data){
                LocalizeSelection.__super__.update.call(this, data);
                this.$selection.find('.select2-selection__rendered').removeAttr('title');
                // verify that notranslate is added to select2-selection__choice if a notranslate var is inside
                this.$selection.find('.select2-selection__choice').each(function(ind, el){
                    $el = $(el)
                    // remove title for localize but store data attribute for use by other libraries
                    $el.data('title', $el.prop('title')).removeAttr('title');
                    if($el.find("var").length > 0) $(el)[0].setAttribute('notranslate', 'notranslate');
                });
            };

            var adapter = LocalizeSelection;

            // Decorate with needeed adapters based on options
            // https://github.com/select2/select2/blob/master/src/js/select2/defaults.js#L187

            if (options.placeholder) {
                adapter = Utils.Decorate(
                    adapter,
                    Placeholder
                );
            }
            if (options.minimumResultsForSearch !== 0) {
                adapter = Utils.Decorate(
                    adapter,
                    MinimumResultsForSearch
                );
            }
            if (options.allowClear) {
                AllowClear.prototype.update = function (decorated, data) {
                  decorated.call(this, data);

                  if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
                      data.length === 0) {
                    return;
                  }

                  var $remove = $(
                    '<span ignore class="select2-selection__clear">' +
                      '&times;' +
                    '</span>'
                  );
                  $remove.data('data', data);

                  this.$selection.find('.select2-selection__rendered').prepend($remove);
                };

                adapter = Utils.Decorate(
                    adapter,
                    AllowClear
                );
            }
            if (options.multiple) {
                adapter = Utils.Decorate(
                    adapter,
                    SelectionSearch
                );
            }
            adapter = Utils.Decorate(
                adapter,
                EventRelay
            );

            return adapter;
        }
    });

})($);



// WEBPACK FOOTER //
// ./app/javascript/lib/vendor_extensions/select2_localize_adapter.js